var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSniperRifle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 60,
    viewBox: "0 0 120 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M117.87 24.114C116.969 23.4045 116.294 23.3115 116.294 23.3115C116.294 23.3115 113.274 23.0115 111.648 23.016C110.022 23.0205 108.663 24.2835 108.663 24.2835L90.0241 24.2415L89.6011 23.28L88.5871 22.4265L86.0461 22.4685L84.9181 23.598L83.7736 23.778L82.8166 24.201H75.1576L74.9881 22.68L74.1436 22.215H72.5806L71.6251 22.764H59.2771L58.5601 22.4685L59.4046 21.201H65.3596V16.26H57.3346L55.5601 17.1885L54.4201 16.7235H51.1261L49.7326 16.047H48.2551V14.865H45.5941C45.4246 14.865 45.1711 16.596 45.1711 16.596H43.8616L42.8896 16.131H41.7916L40.6096 17.145H36.4711L36.6961 20.376L37.7101 21.1995L41.2441 21.3255L41.2021 22.4655H37.9501L37.2751 22.9725V23.5635H36.0391L35.2891 23.817L32.1916 23.8515L30.6781 23.469L28.2346 23.394L24.5176 22.971L9.60913 22.7595L8.03263 23.3505H5.72413C3.41563 23.3505 3.10513 25.4625 3.10513 25.4625L2.88013 39.54L3.86563 41.004L5.47063 40.863L6.51313 39.624H13.4956L14.3401 37.485H21.9421L26.8651 40.7505L30.9511 40.2435L31.3876 39.03L32.3746 36.9495L34.5271 33.1905C34.5271 33.1905 37.2016 33.528 37.6531 33.528C38.1046 33.528 37.7701 35.7405 37.7791 35.9775C37.7881 36.2145 38.6656 36.822 38.6656 36.822L38.5396 38.004L37.3306 39.0285C37.3306 39.0285 37.5256 40.158 37.9486 40.7205C38.3716 41.283 39.8071 41.637 39.8071 41.637C39.8071 41.637 43.1701 41.6175 44.4946 41.535C45.8191 41.4525 48.3586 41.004 48.3586 41.004L52.0966 39.864C52.0966 39.864 52.1281 38.835 52.1386 38.4705C52.1491 38.106 51.6751 37.794 51.6751 37.794L51.7306 35.883C51.7306 35.883 53.0266 35.517 53.1946 35.4075C53.3626 35.298 53.8696 34.584 53.8696 34.584L67.2571 34.4145L68.4391 35.301L72.2401 35.175C72.2401 35.175 73.5871 34.614 73.8631 34.3725C74.1391 34.131 74.1391 33.486 74.1826 33.105C74.2261 32.7255 75.8716 32.8095 75.8716 32.8095L76.5586 33.564L81.7351 34.1145L83.1361 34.611L92.2711 35.3625L94.9651 36.561L96.0466 35.7405L95.5756 35.0565L96.0676 34.2975L96.1036 32.937L94.1446 32.5995L92.9791 32.0085L94.3726 30.9525L96.1471 30.5295V29.559H94.1191L93.3451 29.094H91.3741L90.2761 29.4315L88.3036 29.466C88.3036 29.466 89.0596 28.239 89.4586 27.693C89.8576 27.1455 90.3046 26.3475 90.3046 26.3475H109.788C109.788 26.3475 110.93 27.5055 111.266 27.615C111.602 27.7245 115.14 27.507 115.14 27.507C115.14 27.507 117.225 27.213 118.053 26.9295C118.883 26.646 118.919 26.166 118.928 25.773C118.937 25.38 118.769 24.819 117.867 24.1095L117.87 24.114ZM27.6661 34.884H25.6171C25.6171 34.884 24.3916 34.8 23.8426 33.6165C23.2936 32.4345 24.2221 31.5465 25.2781 30.744H29.3746C29.3746 30.744 30.0496 30.702 30.0496 31.419C30.0496 32.136 27.6631 34.8825 27.6631 34.8825L27.6661 34.884ZM37.9501 32.223L37.2751 32.6025H34.5721L34.1281 32.1585L34.1911 30.363H37.1056L37.9501 30.7425V32.2215V32.223ZM52.2961 24.3675C51.8731 24.5085 50.8036 24.3675 50.8036 24.3675V22.7625H54.2101C54.2101 22.7625 52.7176 24.2265 52.2961 24.3675ZM84.9571 29.2665L84.1546 30H78.0301L77.3971 29.478H74.8636L74.1031 29.013H72.2866V27.957H74.3146L75.1591 27.324V26.31H83.7751L84.9571 26.817V29.2665V29.2665Z",
    fill: "#FAFAFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8665 34.884V40.248",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.02271 30.744H6.65271",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9502 38.325L39.2312 39.0645H40.7522L41.2307 39.741H43.3427L43.9052 39.033H44.8337L45.3437 39.8535H47.2277L51.7322 38.4735",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7524 39.0645L40.9204 36.8265",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5803 39.033L44.8413 36.9525",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1594 39.261L49.4519 36.3315",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8713 32.6025L56.1108 34.377",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8276 32.6025L59.2786 34.377",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7846 32.6025L62.1936 34.377",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1487 34.377L65.6977 32.6025",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4048 21.1995V16.2585L59.2788 18.729L55.5618 17.187",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1731 16.5961L51.5496 16.7236",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7524 17.2725L43.7359 18.285H57.9694",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7358 18.285V22.467",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7964 27.2385V25.0425H53.1964",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5688 27.2385H41.4558L42.3003 28.155H53.0283",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M11.301 23.3535V27.2385",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4512 23.5965C22.6207 23.565 22.8307 24.663 22.4512 25.296C22.0717 25.9305 20.4172 26.943 20.4172 26.943",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4631 23.3535V26.2815",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2979 37.797C31.2979 37.797 30.1159 37.2105 30.5374 36.3315C30.9604 35.4525 32.3329 36.657 32.3329 36.657",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6069 35.7285C32.6069 35.7285 31.2764 35.1165 31.7834 34.398C32.2904 33.6795 33.4724 34.6515 33.4724 34.6515",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8665 36.9525H28.11V39.261H26.8665",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9502 34.6725L53.8727 34.5885L54.7172 33.4065C54.7172 33.4065 54.9707 32.646 56.8712 32.604C58.7717 32.562 66.3317 32.604 66.3317 32.604C66.3317 32.604 67.6832 32.3745 68.4857 33.5865C69.2882 34.8 69.6722 35.271 70.5152 35.247",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7463 32.0115H42.2578C41.8146 32.0115 41.4553 32.3708 41.4553 32.814C41.4553 33.2572 41.8146 33.6165 42.2578 33.6165H50.7463C51.1895 33.6165 51.5488 33.2572 51.5488 32.814C51.5488 32.3708 51.1895 32.0115 50.7463 32.0115Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1514 23.973H55.6039C55.2544 23.973 54.9709 24.2564 54.9709 24.606V24.6075C54.9709 24.9571 55.2544 25.2405 55.6039 25.2405H62.1514C62.501 25.2405 62.7844 24.9571 62.7844 24.6075V24.606C62.7844 24.2564 62.501 23.973 62.1514 23.973Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0618 23.973H65.5143C65.1648 23.973 64.8813 24.2564 64.8813 24.606V24.6075C64.8813 24.9571 65.1648 25.2405 65.5143 25.2405H72.0618C72.4114 25.2405 72.6948 24.9571 72.6948 24.6075V24.606C72.6948 24.2564 72.4114 23.973 72.0618 23.973Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0407 26.1405H55.9142C55.611 26.1405 55.3652 26.3863 55.3652 26.6895C55.3652 26.9927 55.611 27.2385 55.9142 27.2385H57.0407C57.3439 27.2385 57.5897 26.9927 57.5897 26.6895C57.5897 26.3863 57.3439 26.1405 57.0407 26.1405Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1904 26.1405H71.0639C70.7607 26.1405 70.5149 26.3863 70.5149 26.6895C70.5149 26.9927 70.7607 27.2385 71.0639 27.2385H72.1904C72.4936 27.2385 72.7394 26.9927 72.7394 26.6895C72.7394 26.3863 72.4936 26.1405 72.1904 26.1405Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8775 26.1405H61.4555C61.1523 26.1405 60.9065 26.3863 60.9065 26.6895C60.9065 26.9927 61.1523 27.2385 61.4555 27.2385H65.8775C66.1807 27.2385 66.4265 26.9927 66.4265 26.6895C66.4265 26.3863 66.1807 26.1405 65.8775 26.1405Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1966 30C53.2761 29.985 68.4291 30 68.4291 30C68.4291 30 68.5701 30.1395 68.2881 30.6465C68.0061 31.1535 67.5561 31.6035 67.5561 31.6035L55.3641 31.8285C55.3641 31.8285 54.2316 31.866 53.8161 31.5195C53.1321 30.9495 52.3236 30.171 53.1966 30V30Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2376 30.843L55.0696 31.7295",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3733 30.843L56.2053 31.7295",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5106 30.843L57.3411 31.7295",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6463 30.843L58.4768 31.7295",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7813 30.843L59.6118 31.7295",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9168 30.843L60.7473 31.7295",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0522 30.843L61.8977 31.659",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1893 30.843L63.0393 31.629",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M64.325 30.843L64.175 31.629",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4606 30.843L65.3167 31.599",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5954 30.843L66.4514 31.599",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1597 34.884C11.0693 34.884 11.8067 34.1466 11.8067 33.237C11.8067 32.3274 11.0693 31.59 10.1597 31.59C9.25008 31.59 8.5127 32.3274 8.5127 33.237C8.5127 34.1466 9.25008 34.884 10.1597 34.884Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8072 36.0796C11.9406 36.0796 12.0487 35.9714 12.0487 35.8381C12.0487 35.7047 11.9406 35.5966 11.8072 35.5966C11.6738 35.5966 11.5657 35.7047 11.5657 35.8381C11.5657 35.9714 11.6738 36.0796 11.8072 36.0796Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M7.8167 36.132C7.97908 36.132 8.1107 36.0004 8.1107 35.838C8.1107 35.6756 7.97908 35.544 7.8167 35.544C7.65433 35.544 7.52271 35.6756 7.52271 35.838C7.52271 36.0004 7.65433 36.132 7.8167 36.132Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M83.1409 24.198V26.1405",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M84.7463 23.7765V26.6895",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M90.3059 24.606V26.352",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M85.2378 27.6975H89.4603",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M87.7725 26.3099C88.0674 26.3099 88.3065 26.0709 88.3065 25.7759C88.3065 25.481 88.0674 25.2419 87.7725 25.2419C87.4776 25.2419 87.2385 25.481 87.2385 25.7759C87.2385 26.0709 87.4776 26.3099 87.7725 26.3099Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M113.564 27.2385L114.126 25.479L113.564 24.198C113.564 24.198 114.465 23.6355 114.972 24.282C115.479 24.93 115.761 25.479 115.761 25.479L115.029 27.2385",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M116.633 27.2385C116.661 27.0135 116.97 25.296 116.97 25.296L116.295 24.282C116.295 24.282 117.039 23.505 117.872 24.1125C118.704 24.72 118.262 26.835 118.262 26.835",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M114.126 25.479L110.522 25.071V23.2785",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M110.521 25.071L110.184 26.6475",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M115.76 25.479L116.97 25.296",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3147 31.659L74.1457 31.287L76.1722 31.473V32.5845L75.3847 32.8995L73.3147 32.6025",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1721 31.473L82.5501 32.307L83.3946 31.659L92.0106 32.4345",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1721 32.5845L92.9811 34.377L94.0371 32.8995",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M92.9808 34.377L92.8323 35.745",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M85.998 32.8215C86.0253 32.8215 86.0475 32.7994 86.0475 32.772C86.0475 32.7447 86.0253 32.7225 85.998 32.7225C85.9707 32.7225 85.9485 32.7447 85.9485 32.772C85.9485 32.7994 85.9707 32.8215 85.998 32.8215Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M87.7731 33.0119C87.8045 33.0119 87.8301 32.9864 87.8301 32.9549C87.8301 32.9235 87.8045 32.8979 87.7731 32.8979C87.7416 32.8979 87.7161 32.9235 87.7161 32.9549C87.7161 32.9864 87.7416 33.0119 87.7731 33.0119Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M89.5608 33.1515C89.584 33.1515 89.6028 33.1327 89.6028 33.1095C89.6028 33.0863 89.584 33.0675 89.5608 33.0675C89.5376 33.0675 89.5188 33.0863 89.5188 33.1095C89.5188 33.1327 89.5376 33.1515 89.5608 33.1515Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M91.3759 33.399C91.4032 33.399 91.4254 33.3769 91.4254 33.3495C91.4254 33.3222 91.4032 33.3 91.3759 33.3C91.3486 33.3 91.3264 33.3222 91.3264 33.3495C91.3264 33.3769 91.3486 33.399 91.3759 33.399Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M87.9123 31.8856V29.2816H85.2378V31.6756",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M85.9485 30.2521H87.153",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M42.449 29.2665C42.449 29.2665 42.0905 30.174 42.998 30.5325C43.9055 30.8925 44.8415 31.221 44.8415 31.221C44.8415 31.221 46.0805 31.4205 46.883 30.9975C47.6855 30.5745 48.3605 29.667 48.2135 29.4135",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7815 21.1995V18.399H39.992H41.2025V21.1995",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9915 21.1995V18.399",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M45.344 19.9185H46.5035H48.5795",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2993 22.7625V19.9185",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7629 19.9185V22.7625",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0774 23.874L35.7959 25.0425",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7378 22.7625V24.945",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1966 37.4882H14.6786L13.4966 39.6287H6.5141L5.4716 40.8677L3.8666 41.0087C3.8666 41.0087 2.9381 39.9107 2.8811 39.5447L3.1061 25.4672C3.1061 25.4672 2.9801 23.3132 6.1886 23.3552H8.6381L9.3131 22.9757H24.5171C24.5171 22.9757 27.0086 23.3552 28.2341 23.3987C29.4596 23.4422 31.0211 23.3147 31.3166 23.7362L35.2871 23.8202L35.7101 23.5667H37.2731V22.9757L37.7801 22.5107H41.2436V21.3287H37.4846L36.4286 20.4002L36.4706 17.1482H40.6091L41.7911 16.1342H42.8891L43.8611 16.5992H45.3821V14.8682H48.2546V16.0502H49.7321L51.1256 16.7252H54.4196L55.5596 17.1902L57.3341 16.2617H65.3591V21.2027H59.4041C59.4041 21.2027 59.6156 22.2587 57.2081 22.7657H72.1166L72.5816 22.2167H74.6516L74.9891 22.6817V24.2027H83.1401L83.7731 23.7797H84.7451L85.9706 22.5122L88.5896 22.4282L89.3921 22.9772L90.0251 24.2447L109.072 24.2867C109.072 24.2867 110.001 23.1467 111.649 23.0192C113.296 22.8932 116.76 23.2727 117.351 23.5682C117.942 23.8637 118.872 24.7082 118.914 25.1732C118.956 25.6382 118.914 26.3987 118.914 26.3987C118.914 26.3987 118.239 27.1592 116.211 27.4127C114.184 27.6662 111.27 27.6242 111.27 27.6242C111.27 27.6242 109.96 27.3287 109.792 26.3567H90.1106L89.3501 27.9407L87.9146 29.4827L90.2801 29.4407L90.9131 29.1032H93.8276L94.1231 29.5682H96.1496V30.5822L95.6426 30.9617H94.3751L93.7001 31.4687H91.7996C91.7996 31.4687 91.0811 31.9337 92.0111 32.4407L93.6581 32.5247L96.1076 32.9477L95.9816 33.4127L97.1216 34.0457L95.7701 34.3832L95.5586 35.1437L96.6146 36.0302L95.3891 36.1997L95.2631 36.6647L92.9831 35.9462L92.5601 35.3972L82.8041 34.5947L82.1711 34.1717L76.2161 33.5387L75.8786 32.8202L74.1896 33.1157L74.0636 34.2137L73.3886 34.8047L72.2486 35.1842L71.3621 35.2262L68.4476 35.3102L67.2656 34.4237L53.8781 34.5932C53.8781 34.5932 53.4131 35.5217 52.6961 35.6492C51.9776 35.7752 51.7676 35.8607 51.7241 36.5777C51.6821 37.2962 51.6821 38.0132 51.6821 38.0132L52.1471 38.4782L52.1051 39.8717C52.1051 39.8717 49.0646 40.9697 46.7831 41.3072C44.5031 41.6447 40.3211 41.7722 39.8141 41.6447C39.3071 41.5187 37.8296 40.9697 37.5341 40.1672C37.2386 39.3647 37.3646 38.6462 37.3646 38.6462L38.5466 38.0132L38.6726 36.8312C38.6726 36.8312 37.7861 36.1562 37.7861 35.9867C37.7861 35.8172 37.6601 33.5372 37.6601 33.5372H35.3366L34.5341 33.1997L31.7051 38.1407C31.7051 38.1407 31.3676 38.7737 31.3256 39.4082C31.2836 40.0427 31.0301 40.1687 30.5651 40.2947C30.1001 40.4207 26.6801 40.5062 26.6801 40.5062L22.2026 37.4942L22.1966 37.4882Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2795 30.7442H29.376C29.376 30.7442 30.051 30.7022 30.051 31.4192C30.051 32.1362 27.6645 34.8827 27.6645 34.8827H25.6155C25.6155 34.8827 24.39 34.7987 23.841 33.6152C23.292 32.4332 24.2205 31.5452 25.2765 30.7427L25.2795 30.7442Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1902 30.3646H37.1047L37.9492 30.7441V32.2231L37.2727 32.6026H34.5712L34.1272 32.1601L34.1902 30.3646Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2082 22.7626H50.8032H41.2017",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8032 22.7626V24.3676C50.8032 24.3676 51.8727 24.5086 52.2957 24.3676C52.7187 24.2266 54.2097 22.7626 54.2097 22.7626H50.8032Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1571 24.1982V27.3242L74.3126 27.9572H53.1956V23.5967",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2864 27.9572V29.0132H74.1014L74.8619 29.4782H77.3969L78.0299 30.0002H84.1544L84.9569 29.2667V26.8172L83.7734 26.3102H75.1574V27.3242L74.3129 27.9572H72.2864Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3184 23.7346C31.3184 23.7346 32.1914 24.5371 32.1914 25.3261C32.1914 26.1151 31.4594 26.2276 30.0509 26.2831C28.6424 26.3386 26.1659 26.2831 26.1659 26.2831L23.6804 27.2401H9.44239C9.44239 27.2401 9.86539 23.6356 8.63989 23.3536",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M7.35863 23.5967C7.35863 23.5967 8.03363 24.2552 7.97813 25.5497C7.92113 26.8442 7.67063 27.9572 7.67063 27.9572L6.68363 28.7897L6.54863 37.4882L6.51562 39.6272",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M6.54712 37.4882H12.5396L14.7356 33.3767C14.7356 33.3767 15.2426 30.7502 19.1276 30.7502C23.0126 30.7502 34.1906 30.3632 34.1906 30.3632",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6802 27.2386H39.5682L40.6947 29.2666H52.5057L53.1957 27.9571",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6682 36.8267H40.9197L41.9337 35.8547H44.1867L44.8062 36.8267H46.1577L52.0182 35.8382",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M109.073 24.2837V26.3102",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8347 33.4907C72.6515 33.4907 73.3137 32.8285 73.3137 32.0117C73.3137 31.1948 72.6515 30.5327 71.8347 30.5327C71.0179 30.5327 70.3557 31.1948 70.3557 32.0117C70.3557 32.8285 71.0179 33.4907 71.8347 33.4907Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6936 30.5327L81.4071 22.7627",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3562 35.2217C71.3562 35.2217 71.0472 36.9527 70.0887 36.8267C69.1317 36.7007 69.0747 35.2472 69.0747 35.2472",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3997 39.6287C10.3997 39.6287 10.2302 41.0372 9.21765 41.1497C8.20365 41.2622 7.81665 39.6287 7.81665 39.6287",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSniperRifle);
export default __webpack_public_path__ + "static/media/Sniper Rifle.95bb979c2e484cea8e42146d6dc4331c.svg";
export { ForwardRef as ReactComponent };